import '@modifi/plugin-authentication/register'
import '@modifi/plugin-authorization/register'
import '@modifi/plugin-dialogs/register'
import '@modifi/plugin-documents/register'
import {init as i18nInit} from '@modifi/plugin-i18n/register'
import '@modifi/plugin-banners/register'

export const initPlugins = (options = {}) => Promise.all([i18nInit(options?.i18n)])
